import React, { useState, useRef, useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { MovingBG } from './MovingBG';
import { FuturisticBG } from './FuturisticBG';

/* ═══════════════════════════════════════════════════════════════════════════
   PHOTOS SECTION - Auto-Slide Dragon Zigzag v5
   - Auto-slide dengan zigzag wave (slow)
   - Speed boost bila scroll
   - Manual drag support
   - Kembali ke normal speed bila stop scroll
═══════════════════════════════════════════════════════════════════════════ */

// Helper functions for card styling (extracted to reduce complexity)
const getCardShadow = (isHovered, isOuterCard) => {
  if (isHovered && isOuterCard) {
    return '0 0 20px 8px rgba(249,115,22,0.5), 0 0 40px 12px rgba(249,115,22,0.3), 0 10px 30px rgba(0,0,0,0.5)';
  }
  if (isHovered) {
    return '0 0 12px 2px rgba(249,115,22,0.2), 0 5px 20px rgba(0,0,0,0.4)';
  }
  if (isOuterCard) {
    return '0 0 15px 4px rgba(249,115,22,0.3), 0 5px 15px rgba(0,0,0,0.4)';
  }
  return '0 5px 15px rgba(0,0,0,0.4)';
};

const getCardBorder = (isHovered, isOuterCard) => {
  if (!isOuterCard) return 'none';
  return isHovered ? '2px solid rgba(249,115,22,0.6)' : '1px solid rgba(249,115,22,0.3)';
};

const photoCategories = [
  {
    id: 1,
    name: "BMW M4 DIN PABLO",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/BMW_M4_DIN_PABLO/DSC07861.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/BMW_M4_DIN_PABLO/DSC07957.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/BMW_M4_DIN_PABLO/DSC08028.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/BMW_M4_DIN_PABLO/DSC08230.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/BMW_M4_DIN_PABLO/DSC08317.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/BMW%20M4%20DIN%20PABLO/DSC07861.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/BMW%20M4%20DIN%20PABLO/DSC07957.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/BMW%20M4%20DIN%20PABLO/DSC08028.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/BMW%20M4%20DIN%20PABLO/DSC08230.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/BMW%20M4%20DIN%20PABLO/DSC08317.jpg",
    ]
  },
  {
    id: 2,
    name: "FORTYTWOSEVEN CAFE",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/FORTYTWOSEVEN_CAFE/ARZ00512.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/FORTYTWOSEVEN_CAFE/ARZ00722.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/FORTYTWOSEVEN_CAFE/ARZ00927.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/FORTYTWOSEVEN_CAFE/ARZ00995.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/FORTYTWOSEVEN_CAFE/ARZ01085.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/FORTYTWOSEVEN%20CAFE/ARZ00512.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/FORTYTWOSEVEN%20CAFE/ARZ00722.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/FORTYTWOSEVEN%20CAFE/ARZ00927.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/FORTYTWOSEVEN%20CAFE/ARZ00995.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/FORTYTWOSEVEN%20CAFE/ARZ01085.jpg",
    ]
  },
  {
    id: 3,
    name: "IAM MALAYSIA 2025",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/IAM_MALAYSIA_2025/ARZ00972.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/IAM_MALAYSIA_2025/ARZ01534.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/IAM_MALAYSIA_2025/ARZ05202.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/IAM_MALAYSIA_2025/ARZ09895.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/IAM_MALAYSIA_2025/IMG_8439.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/IAM%20MALAYSIA%202025/ARZ00972.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/IAM%20MALAYSIA%202025/ARZ01534.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/IAM%20MALAYSIA%202025/ARZ05202.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/IAM%20MALAYSIA%202025/ARZ09895.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/IAM%20MALAYSIA%202025/IMG_8439.jpg",
    ]
  },
  {
    id: 4,
    name: "INFINITE MOTORSPORT",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/INFINITE_MOTORSPORT_THAILAND/ARZ08752.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/INFINITE_MOTORSPORT_THAILAND/ARZ08777.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/INFINITE_MOTORSPORT_THAILAND/ARZ08929-3.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/INFINITE_MOTORSPORT_THAILAND/ARZ09136-2.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/INFINITE_MOTORSPORT_THAILAND/ARZ09209.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/INFINITE%20MOTORSPORT%20THAILAND/ARZ08752.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/INFINITE%20MOTORSPORT%20THAILAND/ARZ08777.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/INFINITE%20MOTORSPORT%20THAILAND/ARZ08929-3.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/INFINITE%20MOTORSPORT%20THAILAND/ARZ09136-2.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/INFINITE%20MOTORSPORT%20THAILAND/ARZ09209.jpg",
    ]
  },
  {
    id: 5,
    name: "LAMBO REVUELTO",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_REVUELTO_SUPERCARGANGMY/DSC04417-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_REVUELTO_SUPERCARGANGMY/DSC05254-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_REVUELTO_SUPERCARGANGMY/DSC05422.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_REVUELTO_SUPERCARGANGMY/DSC05441-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_REVUELTO_SUPERCARGANGMY/DSC05471-Enhanced-NR-2.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20REVUELTO%20SUPERCARGANGMY/DSC04417-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20REVUELTO%20SUPERCARGANGMY/DSC05254-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20REVUELTO%20SUPERCARGANGMY/DSC05422.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20REVUELTO%20SUPERCARGANGMY/DSC05441-Enhanced-NR.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20REVUELTO%20SUPERCARGANGMY/DSC05471-Enhanced-NR-2.jpg",
    ]
  },
  {
    id: 6,
    name: "LAMBO URUS MANSORY",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_URUS_MANSORY_AMERUL/ARZ05627-2.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_URUS_MANSORY_AMERUL/ARZ07085.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_URUS_MANSORY_AMERUL/ARZ07431.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_URUS_MANSORY_AMERUL/ARZ07495.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/LAMBORGHINI_URUS_MANSORY_AMERUL/LAMBORGHINI_URUS_AMERUL_LAYOUT_1.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20URUS%20MANSORY%20AMERUL/ARZ05627-2.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20URUS%20MANSORY%20AMERUL/ARZ07085.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20URUS%20MANSORY%20AMERUL/ARZ07431.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20URUS%20MANSORY%20AMERUL/ARZ07495.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/LAMBORGHINI%20URUS%20MANSORY%20AMERUL/LAMBORGHINI%20URUS%20AMERUL%20LAYOUT%201.jpg",
    ]
  },
  {
    id: 7,
    name: "MDX DIECAST EXPO",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/MDX_2025_MALAYSIA_DIECAST_EXPO/ARZ06400.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MDX_2025_MALAYSIA_DIECAST_EXPO/ARZ06415-2.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MDX_2025_MALAYSIA_DIECAST_EXPO/ARZ06447.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MDX_2025_MALAYSIA_DIECAST_EXPO/ARZ06583-3.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MDX_2025_MALAYSIA_DIECAST_EXPO/ARZ06612.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/MDX%202025%20MALAYSIA%20DIECAST%20EXPO/ARZ06400.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MDX%202025%20MALAYSIA%20DIECAST%20EXPO/ARZ06415-2.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MDX%202025%20MALAYSIA%20DIECAST%20EXPO/ARZ06447.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MDX%202025%20MALAYSIA%20DIECAST%20EXPO/ARZ06583-3.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MDX%202025%20MALAYSIA%20DIECAST%20EXPO/ARZ06612.jpg",
    ]
  },
  {
    id: 8,
    name: "MEGA SHOW JAPAN",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/MEGA_SHOW_JAPAN/ARZ00629.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MEGA_SHOW_JAPAN/ARZ00644.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MEGA_SHOW_JAPAN/ARZ00665.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MEGA_SHOW_JAPAN/ARZ00777.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/MEGA_SHOW_JAPAN/ARZ00967.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/MEGA%20SHOW%20JAPAN/ARZ00629.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MEGA%20SHOW%20JAPAN/ARZ00644.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MEGA%20SHOW%20JAPAN/ARZ00665.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MEGA%20SHOW%20JAPAN/ARZ00777.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/MEGA%20SHOW%20JAPAN/ARZ00967.jpg",
    ]
  },
  {
    id: 9,
    name: "NISSAN S15 FUJI",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/NISSAN_SILVIA_S15_FUJI/ARZ00969.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/NISSAN_SILVIA_S15_FUJI/ARZ01029.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/NISSAN_SILVIA_S15_FUJI/ARZ01649.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/NISSAN_SILVIA_S15_FUJI/ARZ01656.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/NISSAN_SILVIA_S15_FUJI/ARZ09986.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/NISSAN%20SILVIA%20S15%20FUJI/ARZ00969.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/NISSAN%20SILVIA%20S15%20FUJI/ARZ01029.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/NISSAN%20SILVIA%20S15%20FUJI/ARZ01649.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/NISSAN%20SILVIA%20S15%20FUJI/ARZ01656.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/NISSAN%20SILVIA%20S15%20FUJI/ARZ09986.jpg",
    ]
  },
  {
    id: 10,
    name: "PORSCHE CLUB MY",
    thumbnails: [
      "https://tafworldwide.b-cdn.net/photo-thumbs/PORSCHE_CLUB_MALAYSIA/ARZ04663.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/PORSCHE_CLUB_MALAYSIA/ARZ05266.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/PORSCHE_CLUB_MALAYSIA/ARZ05380.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/PORSCHE_CLUB_MALAYSIA/ARZ05449.jpg",
      "https://tafworldwide.b-cdn.net/photo-thumbs/PORSCHE_CLUB_MALAYSIA/ARZ05449.jpg",
    ],
    images: [
      "https://tafworldwide.b-cdn.net/drive-download/PORSCHE%20CLUB%20MALAYSIA/ARZ04663.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/PORSCHE%20CLUB%20MALAYSIA/ARZ05266.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/PORSCHE%20CLUB%20MALAYSIA/ARZ05380.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/PORSCHE%20CLUB%20MALAYSIA/ARZ05449.jpg",
      "https://tafworldwide.b-cdn.net/drive-download/PORSCHE%20CLUB%20MALAYSIA/DJI_0233.jpg",
    ]
  },
];

// Duplicate categories for infinite loop effect
const displayCategories = [...photoCategories, ...photoCategories, ...photoCategories];

/* ─────────────────────────────────────────────────────────────
   Curved Card Stack with Border Glow Effect
───────────────────────────────────────────────────────────── */
const CurvedCardStack = ({ thumbnails, onClick, isHovered, onHover }) => {
  return (
    <div 
      className="relative w-24 h-32 sm:w-28 sm:h-36 md:w-32 md:h-40 cursor-pointer"
      onClick={onClick}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <div className="relative z-10">
        {thumbnails.slice(0, 5).map((thumb, idx) => {
          const angle = (idx - 2) * 10;
          const offsetY = Math.abs(idx - 2) * 5;
          const offsetX = (idx - 2) * 2;
          const isOuterCard = idx === 0 || idx === 4;
          
          return (
            <div
              key={`card-${thumb}-${idx}`}
              className="absolute left-1/2 w-16 h-24 sm:w-20 sm:h-28 md:w-24 md:h-32 rounded-lg overflow-hidden transition-all duration-300 ease-out"
              style={{
                transform: `
                  translateX(-50%)
                  translateX(${offsetX}px)
                  translateY(${offsetY}px)
                  rotate(${angle}deg)
                  scale(${isHovered ? 1.05 : 1})
                `,
                zIndex: 5 - Math.abs(idx - 2),
                transformOrigin: 'bottom center',
                boxShadow: getCardShadow(isHovered, isOuterCard),
                border: getCardBorder(isHovered, isOuterCard),
              }}
            >
              <img
                src={thumb}
                alt=""
                className="w-full h-full object-cover transition-transform duration-300"
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   Category Item with Zigzag Animation
───────────────────────────────────────────────────────────── */
const CategoryItem = ({ category, index, onClick, scrollX }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isTop = index % 2 === 0;
  
  // Zigzag Y movement based on scrollX position - continuous wave
  const waveAmplitude = 35;
  const wavePhase = (scrollX * 0.008) + (index * 0.7);
  const zigzagY = Math.sin(wavePhase) * waveAmplitude;
  
  // Base Y offset for alternating rows
  const baseY = isTop ? 0 : 55;
  
  // Subtle rotation follows wave
  const rotation = Math.cos(wavePhase) * 3;
  
  return (
    <div
      className="flex flex-col items-center flex-shrink-0"
      style={{
        transform: `translateY(${baseY + zigzagY}px) rotate(${rotation}deg)`,
        willChange: 'transform',
      }}
      data-testid={`photo-category-${category.id}`}
    >
      <CurvedCardStack 
        thumbnails={category.thumbnails} 
        onClick={() => onClick(category)}
        isHovered={isHovered}
        onHover={setIsHovered}
      />
      <p className={`mt-3 text-[10px] sm:text-xs font-medium tracking-wider text-center max-w-[100px] leading-tight transition-colors duration-300 ${
        isHovered ? 'text-orange-400' : 'text-white/70'
      }`}>
        {category.name}
      </p>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   Lightbox Modal
───────────────────────────────────────────────────────────── */
const Lightbox = ({ category, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const touchStartX = useRef(0);
  
  const images = category?.images || [];
  const imagesLength = images.length;
  
  useEffect(() => {
    if (!category) return;
    
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') { setCurrentIndex((p) => (p - 1 + imagesLength) % imagesLength); setIsLoaded(false); }
      if (e.key === 'ArrowRight') { setCurrentIndex((p) => (p + 1) % imagesLength); setIsLoaded(false); }
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [category, imagesLength, onClose]);

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setCurrentIndex((p) => (p + 1) % imagesLength);
      else setCurrentIndex((p) => (p - 1 + imagesLength) % imagesLength);
      setIsLoaded(false);
    }
  };

  if (!category) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/98 backdrop-blur-xl flex items-center justify-center" onClick={onClose}>
      <button onClick={onClose} className="absolute top-4 right-4 sm:top-8 sm:right-8 z-20 w-12 h-12 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10 transition-all" data-testid="lightbox-close">
        <X className="w-6 h-6" />
      </button>

      <div className="absolute top-4 left-4 sm:top-8 sm:left-8 z-20">
        <h3 className="text-white text-lg sm:text-2xl font-black tracking-wider">{category.name}</h3>
        <p className="text-white/40 text-sm mt-1">{currentIndex + 1} / {imagesLength}</p>
      </div>

      <div className="relative w-full h-full flex items-center justify-center px-4 sm:px-20 py-24" onClick={(e) => e.stopPropagation()} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        <button onClick={(e) => { e.stopPropagation(); setCurrentIndex((p) => (p - 1 + imagesLength) % imagesLength); setIsLoaded(false); }} className="absolute left-2 sm:left-8 z-20 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10 transition-all">
          <ChevronLeft className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>
        
        <button onClick={(e) => { e.stopPropagation(); setCurrentIndex((p) => (p + 1) % imagesLength); setIsLoaded(false); }} className="absolute right-2 sm:right-8 z-20 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10 transition-all">
          <ChevronRight className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>

        <div className="relative max-w-6xl w-full h-full flex items-center justify-center">
          {!isLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-10 h-10 border-2 border-orange-500/30 border-t-orange-500 rounded-full animate-spin" />
            </div>
          )}
          <img key={images[currentIndex]} src={images[currentIndex]} alt={`${category.name} ${currentIndex + 1}`} className={`max-w-full max-h-full object-contain rounded-lg shadow-2xl transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} onLoad={() => setIsLoaded(true)} onClick={(e) => e.stopPropagation()} />
        </div>
      </div>

      <div className="absolute bottom-4 sm:bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2 px-4 overflow-x-auto max-w-full">
        {images.map((img, idx) => (
          <button key={`thumb-${img}-${idx}`} onClick={(e) => { e.stopPropagation(); setCurrentIndex(idx); setIsLoaded(false); }} className={`flex-shrink-0 w-14 h-10 sm:w-20 sm:h-14 rounded-md overflow-hidden transition-all ${idx === currentIndex ? 'ring-2 ring-orange-500 ring-offset-2 ring-offset-black scale-105' : 'opacity-40 hover:opacity-70'}`}>
            <img src={category.thumbnails[idx] || img} alt="" className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   Main Photos Component - Auto-Slide with Scroll Speed Boost
───────────────────────────────────────────────────────────── */
export const Photos = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [scrollX, setScrollX] = useState(0);
  const sectionRef = useRef(null);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartScrollX = useRef(0);
  const lastScrollY = useRef(0);
  const scrollSpeedRef = useRef(0);
  const scrollTimeoutRef = useRef(null);

  // Base auto-slide speed (slow)
  const baseSpeed = 0.3;
  const itemWidth = 160; // Approximate item width + gap
  const oneSetWidth = photoCategories.length * itemWidth;
  
  // Normalize scrollX to prevent jumps - keep it within reasonable bounds
  const normalizeScroll = useCallback((value) => {
    // Keep scroll within 0 to 2 sets (for smooth looping)
    if (value < 0) {
      return value + oneSetWidth;
    }
    if (value >= oneSetWidth * 2) {
      return value - oneSetWidth;
    }
    return value;
  }, [oneSetWidth]);
  
  // Auto-slide animation with scroll-speed boost
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    
    const animate = () => {
      if (!isDragging.current) {
        // Calculate current speed: base + scroll boost
        const currentSpeed = baseSpeed + Math.abs(scrollSpeedRef.current) * 0.5;
        
        setScrollX((prev) => {
          const newScroll = prev + currentSpeed;
          return normalizeScroll(newScroll);
        });
      }
      animationRef.current = requestAnimationFrame(animate);
    };
    
    animationRef.current = requestAnimationFrame(animate);
    
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [normalizeScroll]);

  // Track scroll speed - uses refs only, no state dependencies needed
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY.current;
      lastScrollY.current = currentScrollY;
      
      // Set scroll speed (will decay to 0)
      scrollSpeedRef.current = Math.min(Math.abs(delta) * 0.3, 5);
      
      // Clear previous timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      // Decay scroll speed back to 0 after scrolling stops
      scrollTimeoutRef.current = setTimeout(() => {
        scrollSpeedRef.current = 0;
      }, 150);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // Empty deps - only uses refs which are stable

  // Mouse drag handlers
  const handleMouseDown = (e) => {
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartScrollX.current = scrollX;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const diff = dragStartX.current - e.clientX;
    const newScroll = dragStartScrollX.current + diff;
    setScrollX(normalizeScroll(newScroll));
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    // Normalize on release to prevent accumulated drift
    setScrollX(prev => normalizeScroll(prev));
  };

  // Touch handlers - improved for better mobile experience
  const handleTouchStart = (e) => {
    isDragging.current = true;
    dragStartX.current = e.touches[0].clientX;
    dragStartScrollX.current = scrollX;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault(); // Prevent page scroll while swiping slider
    const diff = dragStartX.current - e.touches[0].clientX;
    const newScroll = dragStartScrollX.current + diff;
    setScrollX(normalizeScroll(newScroll));
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
    // Normalize on release to prevent accumulated drift
    setScrollX(prev => normalizeScroll(prev));
  };

  const handleClick = useCallback((category) => {
    if (!isDragging.current) {
      setSelectedCategory(category);
    }
  }, []);

  const handleCloseLightbox = useCallback(() => {
    setSelectedCategory(null);
  }, []);

  return (
    <section
      ref={sectionRef}
      id="photos"
      className="relative py-16 sm:py-20 overflow-hidden"
      style={{ background: '#050505' }}
      data-testid="photos-section"
    >
      {/* Matching background with Meet The Team section */}
      <MovingBG />
      <FuturisticBG density={10} />

      {/* Geometric background - same as Contact section */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #f97316 0px, #f97316 1px, transparent 0px, transparent 50%)',
          backgroundSize: '40px 40px'
        }} />
        <div className="absolute top-1/4 left-0 w-64 h-64 bg-orange-600/12 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-0 w-64 h-64 bg-amber-600/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-500/20 to-transparent" />
      </div>

      <div className="relative z-10">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-10 px-4">
          <span className="inline-block text-orange-500/80 text-xs font-bold tracking-[0.3em] uppercase mb-2">
            Gallery
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white tracking-tight">
            PHOTOS
          </h2>
          <div className="w-16 h-0.5 bg-gradient-to-r from-orange-500 to-amber-500 mx-auto mt-4" />
        </div>

        {/* Horizontal slider container - extra padding for zigzag + text */}
        <div 
          ref={sliderRef}
          className="flex items-start gap-6 sm:gap-10 px-8 sm:px-16 cursor-grab select-none active:cursor-grabbing"
          style={{ 
            transform: `translateX(-${scrollX}px)`,
            paddingTop: '30px',
            paddingBottom: '120px', /* Extra space for zigzag down + text */
            minHeight: '320px',
            touchAction: 'pan-y pinch-zoom', /* Allow vertical scroll, capture horizontal */
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {displayCategories.map((category, index) => (
            <CategoryItem
              key={`${category.id}-${index}`}
              category={category}
              index={index}
              onClick={handleClick}
              scrollX={scrollX}
            />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox category={selectedCategory} onClose={handleCloseLightbox} />
    </section>
  );
};

export default Photos;
